import React from 'react';
import Row from '@amzn/meridian/row';
import Loader from '@amzn/meridian/loader';

const LoadingSpinner = () => {
  return (
    <div role="progressbar">
      <Row alignmentHorizontal="center" alignmentVertical="center" spacingInset="500">
        <Loader />
      </Row>
    </div>
  );
};

export default LoadingSpinner;
